var $7f5e57085d7f5049$exports = {};
$7f5e57085d7f5049$exports = {
  "calendar": "Kalend\xE1r",
  "day": "de\u0148",
  "dayPeriod": "AM/PM",
  "endDate": "D\xE1tum ukon\u010Denia",
  "era": "letopo\u010Det",
  "hour": "hodina",
  "minute": "min\xFAta",
  "month": "mesiac",
  "second": "sekunda",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Vybrat\xFD d\xE1tum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Vybrat\xFD rozsah: od ".concat(args.startDate, " do ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Vybrat\xFD \u010Das: ".concat(args.time);
  },
  "startDate": "D\xE1tum za\u010Datia",
  "timeZoneName": "\u010Dasov\xE9 p\xE1smo",
  "weekday": "de\u0148 t\xFD\u017Ed\u0148a",
  "year": "rok"
};
export { $7f5e57085d7f5049$exports as default };